import loadable from '@loadable/component';

export const AnimatedEyesImage = loadable(() => import('./animated-eyes'));
